export default {
  text: '#f7f7f7',
  primary: '#EA232D',
  secondary: '#99272c',
  background: '#111',
  backgroundSecondary: '#e3e3db',
  light: '#f7f7f7',
  dark: '#111'
}
